import {FormControlLabel as MUIFormControlLabel} from '@mui/material';
import PropTypes from 'prop-types';
import React from 'react';

const FormControlLabel = props => (
  <MUIFormControlLabel
    sx={{
      width: '100%',
      '& .MuiFormControlLabel-label': {
        fontWeight: props.checked ? 'fontWeightMedium' : 'fontWeightRegular',
      },
    }}
    {...props}
  />
);

FormControlLabel.propTypes = {
  checked: PropTypes.bool,
};

export default FormControlLabel;
